import { CartItemProps } from "../types";
import { useProductTranslations } from "../../../hooks/TranslationHooks";
import { Input } from "reactstrap";
import classNames from "classnames";
import FormattedPrice from "../../FormattedPrice";
import { multiply } from "../../../utils/NumberUtils";
import { productIsPerSquareMeter } from "../../../utils/ProductUtils";
import stockIconOK from "../../../assets/icons/stock_ok.svg";
import stockIconWarn from "../../../assets/icons/stock_warn.svg";
import stockIconTime from "../../../assets/icons/stock_time.svg";
import stockIconEmpty from "../../../assets/icons/stock_empty.svg";
import stockIconUnknown from "../../../assets/icons/stock_unknown.svg";
import Icon from "../../Icon";
import ConditionalLink from "../../ConditionalLink/ConditionalLink";

const NormalCartItem = ({
  to,
  previewImage,
  productName,
  productSku,
  amount,
  updateAmount,
  removeFromCart,
  currency,
  price,
  total,
  unitPrice,
  priceUnit,
  unitQuantityFactor,
  stockStatus,
  availableStock = 0,
  isSample = false,
  b2b = false
}: CartItemProps) => {
  const tp = useProductTranslations();
  const isPerSquareMeter = productIsPerSquareMeter(unitQuantityFactor);
  return (
    <li className={classNames("cart-item", { b2b: b2b })} data-sku={productSku}>
      <div className={"image-column"}>
        <ConditionalLink to={to}>
          <img className={"w-100"} src={previewImage} alt={"Product"} />
        </ConditionalLink>
      </div>
      <div className={"content-columns"}>
        <div className={"padded-column info-column"}>
          <div className="info-cell">
            <ConditionalLink to={to} className={"text-black"}>
              <h4>
                {b2b && <span className="text-pale">{productSku} </span>}
                {isSample && tp("sample") + ": "}
                {productName}
              </h4>
            </ConditionalLink>
            {!b2b && (
              <div className="sku text-small text-pale">
                {tp("article_number")}: {productSku}
              </div>
            )}
          </div>
          <div className="status-cell">
            {!isSample && stockStatus && stockStatus.cartIcon && (
              <div style={{ lineHeight: 1.1 }}>
                <img
                  data-status={stockStatus.cartIcon}
                  src={
                    stockStatus.cartIcon === "ok"
                      ? stockIconOK
                      : stockStatus.cartIcon === "warn"
                      ? stockIconWarn
                      : stockStatus.cartIcon === "time"
                      ? stockIconTime
                      : stockStatus.cartIcon === "empty"
                      ? stockIconEmpty
                      : stockIconUnknown
                  }
                  className="icon"
                  alt=""
                />{" "}
                <span
                  className={classNames({
                    "text-small": true,
                    "text-pale": stockStatus.cartIcon === "ok",
                    "text-bold": stockStatus.cartIcon !== "ok"
                  })}
                >
                  {stockStatus.message}
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={"padded-column amount-column"}>
          <div className="amount-cell">
            {!isSample &&
              (typeof updateAmount === "function" ? (
                <>
                  <Input
                    type={"number"}
                    value={amount}
                    max={availableStock || 999}
                    onChange={updateAmount}
                    aria-label={tp("sales_unit." + priceUnit)}
                  />
                  <span className="text-small">
                    {tp("sales_unit." + priceUnit)}
                  </span>
                </>
              ) : (
                <strong className="amount-text">
                  {amount} {tp("sales_unit." + priceUnit)}
                </strong>
              ))}
            {!isSample && isPerSquareMeter && (
              <span className="second-unit">
                ({multiply(unitQuantityFactor, amount)}&nbsp;m&sup2;)
              </span>
            )}
          </div>

          {!isSample && price > 0 && (
            <>
              <div className="amount-cell">
                {isPerSquareMeter && unitPrice > 0 && (
                  <div className={"d-inline-block me-3"}>
                    <FormattedPrice
                      currency={currency}
                      price={unitPrice}
                      price_unit={priceUnit}
                      bold_price={true}
                    />
                  </div>
                )}
                <div
                  className={classNames("d-inline-block", {
                    "text-small text-pale": isPerSquareMeter
                  })}
                >
                  <FormattedPrice
                    currency={currency}
                    price={price}
                    sales_unit={priceUnit}
                    bold_price={!isPerSquareMeter}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        <div className={"padded-column total-column"}>
          <div className={"total-cell text-end"}>
            <FormattedPrice
              currency={currency}
              bold_price={true}
              price={total || multiply(price, amount)}
            />
          </div>
        </div>
      </div>
      {typeof removeFromCart == "function" && (
        <div className={"icons"}>
          <button
            className={"btn btn-remove"}
            onClick={e => {
              e.stopPropagation();
              removeFromCart();
            }}
          >
            <Icon name="trash" />
          </button>
        </div>
      )}
    </li>
  );
};

export default NormalCartItem;
